import React from "react";
import { Box } from "@hightouch/htui";
import { SkeletonItem, SkeletonItemProps } from "./skeleton-item";

interface Props extends SkeletonItemProps {
  isLoading: boolean;
  children: React.ReactNode;
}

/**
 * Wrap this component around an element to render it as a skeleton while `isLoading` is true.
 *
 * This is useful if the child element has a pre-defined height/width and does
 * not need to wait for the content to load.
 */
export const Skeleton = ({
  isLoading,
  children,
  ...skeletonItemProps
}: Props) => {
  if (isLoading) {
    return (
      <SkeletonItem {...skeletonItemProps}>
        <Box display="flex" visibility="hidden">
          {children}
        </Box>
      </SkeletonItem>
    );
  }

  return <>{children}</>;
};
